import React from 'react';

import { SelectOption } from '../../utils/models';
import useInspectionTypes from '../../hooks/useInspectionTypes';

function withInspectionTypes(Component: any): React.FC<any> {
	return function WithInspectionTypes(props): JSX.Element {
		const { data, error, loading, lastUpdated, refetch  } = useInspectionTypes();

		return (
			<Component
				types={data.filter((type: SelectOption) => type.name)}
				typesLoading={loading}
				typesError={error}
				refreshTypes={refetch}
				typesLastUpdated={lastUpdated}
				{...props}
			/>
		);
	};
}

export default withInspectionTypes;
